module.exports = __webpack_public_path__ + "startpage-746fed5a/uberzeugender-einleitungssatz-so-ge-471b754dfb49a3864adab5183fa4d3d8.jpeg";